import React from "react";
import {
  FormControl,
  FormErrorMessage,
  FormLabel,
  NumberInput,
  NumberInputField,
  NumberInputStepper,
  NumberIncrementStepper,
  NumberDecrementStepper,
  FormHelperText,
} from "@chakra-ui/react";
const Numbers = ({ options, formik, id }) => {
  const styleClasses =
    options.styleClasses && options.styleClasses.length
      ? options.styleClasses.join(" ")
      : "";
  const numberErrors =
    Object.keys(formik.errors).length &&
    formik.errors.number &&
    formik.errors.number.length &&
    formik.errors.number[id];
  const numberTouched =
    Object.keys(formik.touched).length &&
    formik.touched.number &&
    formik.touched.number.length &&
    formik.touched.number[id];
  const hasError = numberTouched && numberErrors;

  const onChangenumber = (e, id) => {
    const setValues = formik.setValues;
    const formikValues = formik.values;
    const number = [...formik.values.number];
    const currentValues = e.target.value;
    let newUpdateValue = true;
    Object.keys(formikValues.number).some((field, i) => {
      Object.keys(formikValues.number[i]) == e.target.name &&
        (formikValues.number[i][e.target.name] = e.target.value);
      if (
        formikValues.number.length - 1 == i &&
        Object.keys(formikValues.number[i]) == e.target.name
      ) {
        newUpdateValue = false;
      }
      if (!newUpdateValue) {
        return;
      }
    });
    if (newUpdateValue) {
      const currentValuesWithId = {
        [e.target.name]: currentValues,
      };
      number.push(currentValuesWithId);
    }
    setValues({ ...formikValues, number });
  };

  return (
    <FormControl
      className={styleClasses}
      isInvalid={hasError ? true : false}
      mb="2"
      isRequired={options.isRequired}
    >
      {options.showLabel && (
        <FormLabel htmlFor="number" fontSize="14px">
          {options.label}
        </FormLabel>
      )}
      <NumberInput name={`number.${id}.name`}>
        <NumberInputField
          onChange={(e) => {
            onChangenumber(e, id);
          }}
          value={formik.values && formik.values["number"][`number.${id}.name`]}
        />
        <NumberInputStepper>
          <NumberIncrementStepper />
          <NumberDecrementStepper />
        </NumberInputStepper>
      </NumberInput>
      <FormHelperText>{options.helpText}</FormHelperText>
      {hasError ? (
        <FormErrorMessage>{formik.errors.number}</FormErrorMessage>
      ) : null}
    </FormControl>
  );
};

export default Numbers;
